import { render } from "./Discord.vue?vue&type=template&id=876ee6f0"
import script from "./Discord.vue?vue&type=script&lang=js"
export * from "./Discord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__